<template>
    <div class="sub-footer">
        <div class="container">
            <div class="row no-gutters">
                <div class="col-lg-3 col-sm-4 col-6">
                    <ul class='menu'>
                        <li><a href="#/">{{tr.home_page}}</a></li>
                        <li><a href="#/posts#header">{{tr.publications}}</a></li>
                        <li><a href="#/events#header">{{tr.main_events}}</a></li>
                    </ul>
                </div>
                <div class="col-lg-3 col-sm-4 col-6">
                    <ul class='menu'>
                        <li><a href="#/for-media">{{tr.for_media}}</a></li>
                        <li><a href="#/about">{{tr.about_iwep}}</a></li>
                        <!-- <li><a href="#/experts">{{tr.experts}}</a></li> -->
                    </ul>
                </div>
                <div class="col-lg-3 col-sm-4 d-none d-sm-block">
                    <ul class='menu'>
                        <li><a href="#/contacts">{{tr.contacts}}</a></li>
                        <li><a href="#/multimedia">{{tr.multimedia}}</a></li>
                    </ul>
                </div>
                <div class="col-sm-12 d-lg-none"><br /><br /></div>
                <div class="col-lg-3 col-sm-12 text-center">
                    {{tr.we_are_in_social_networks}}:
                    <div class="socials">
                        <a href="https://www.facebook.com/kz.iwep/?modal=suggested_action" target="_blank"><div class="fab fa-facebook-square"></div></a>
                        <a href="http://instagram.com/iwepkz" target="_blank"><div class="fab fa-instagram"></div></a>
                        <a href="https://t.me/iwepkz" target="_blank"><div class="fab fa-telegram"></div></a>
                        <a href="https://www.youtube.com/channel/UCU9qj3LruqFcDAufKrV2YAg" target="_blank"><div class="fab fa-youtube"></div></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

    name: 'sub-footer',

    computed: {
        lang() { return this.$store.state.lang; },
        tr() { return this.$store.getters.translates; }
    },
    data() {
        return {
            background: require("../assets/img/world-map.png")

        }
    }
}
</script>
<style lang="css" scoped>
.sub-footer {
    /*background: #254d77;*/
    /*background: #18719c;*/
    padding: 32px 0;
    color: white;
    background-image: url(/dist/world-map.png);
    background-size: contain;
    background-position: center;

}

.sub-footer ul {
    padding: 0;
    margin: 0;
    line-height: 2;
}

.menu li {
    list-style: none;
}

.menu li a {
    color: white;
    text-decoration: none;
    cursor: pointer;
    text-transform: uppercase;
}

.menu li a:hover {
    text-decoration: underline;
}

.socials {
    margin-top: 4px;
}

.socials>a {
    font-size: 32px;
    margin: 4px;
    color: white;
    text-decoration: none;
}

.socials>a:hover {
    color: lightgrey;
    cursor: pointer;
}
</style>